import React from 'react';
import {
  Button, Form, InputNumber, Select,
} from 'antd';
import { useAuth } from '../../contexts/userContext/userContext';
import useTranslation from '../../hooks/translation/useTranslation';

function SuggestedStationForm({
  form, onFinish, isLoading,
}) {
  const { trans, currentLanguage } = useTranslation();
  const {
    ticketBookingOptions: { stations },
  } = useAuth();
  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
    >
      <Form.Item
        label={trans('station')}
        name="station_code"
      >
        <Select
          options={
          stations?.map((station) => ({
            label: station?.[`label_${currentLanguage === 'am' ? 'ka' : currentLanguage}`],
            value: station?.value,
          }))
        }
          showSearch
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
        />
      </Form.Item>
      <Form.Item
        label={trans('direction')}
        name="direction"
      >
        <Select
          options={[{
            label: trans('departure'),
            value: 'departure',
          }, {
            label: trans('arrival'),
            value: 'arrival',
          }]}
          showSearch
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
        />
      </Form.Item>
      <Form.Item
        label={trans('order')}
        name="order"
      >
        <InputNumber min={1} />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          {trans('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default SuggestedStationForm;
